<template>
  <div>
    <div style="display: flex;flex-direction: column;gap: 8px;">
      <el-row style="height: 60px;" :gutter="20">
        <el-col :span="3" style="height: 100%; display: flex; align-items: center; font-size: 18px;">
          {{ calculateLabel }}
        </el-col>
        <el-col
          :span="15"
          style="height: 100%; display: flex; align-items: center; justify-content: end; border: solid 3px #E5E7EB; background: #ffffff; border-radius: 8px; padding-right: 16px; font-size: 30px;color: #000000;"
        >
          <div style="max-width: 100%; overflow-x: auto; white-space: nowrap;">
            {{ adjustPriceItem.amount }}
          </div>
        </el-col>
        <el-col :span="6" style="height: 100%; display: flex; align-items: center;">
          <el-button style="height: 100%; width:100%;border: solid 3px #E5E7EB; border-radius: 8px;font-size: 26px;" @click="clearInput">C</el-button>
        </el-col>
      </el-row>
      <el-row v-for="(row, rowIndex) in keypad" :key="rowIndex" :gutter="12" style="height: 60px; margin-bottom: 12px;">
        <el-col v-for="key in row" :key="key" :span="6" style="height: 100%; display: flex; align-items: center;">
          <el-button style="height: 100%; width: 100%; border: solid 3px #E5E7EB; border-radius: 8px; font-size: 26px;" @click="updateInput(key)">
            {{ key }}
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalculatorPartial',
  components: {},
  props: {
    type: {
      type: String,
      required: true,
    },
    currentPayTotal: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      adjustPriceItem: { itemType: 'price', type: this.type, qty: 1, amount: '0' },
      keypad: [['7', '8', '9', '0'], ['4', '5', '6', '00'], ['1', '2', '3', '000']],
    }
  },
  computed: {
    calculateLabel() {
      const map = {
        add: '加價',
        minus: '減價',
        discount: '折扣%',
      }
      return map[this.type] || '未知'
    },
  },
  methods: {
    updateInput(val) {
      // 1. 處理字串累加 (這決定了畫面上顯示的數字)
      const isOnlyZeros = val.split('').every((char) => char === '0')

      if (this.adjustPriceItem.amount === '0') {
        if (isOnlyZeros) return
        this.adjustPriceItem.amount = val
      } else {
        this.adjustPriceItem.amount += val
      }

      //  Discount 邏輯額外處理顯示與計算
      // 拷貝一份目前的物件，避免直接修改到畫面上正在顯示的 amount
      const outputData = { ...this.adjustPriceItem }

      if (this.adjustPriceItem.type === 'discount') {
        // 取得使用者輸入的百分比 (例如 9)
        const percent = Number(this.adjustPriceItem.amount) || 0
        console.log('percent', percent)
        // 計算實際金額 (例如 500 * 0.09 = 45)
        // 這裡直接使用你傳進來的 currentPayTotal
        const calculatedAmount = Math.round(this.currentPayTotal * (percent / 100))
        console.log('calculatedAmount', calculatedAmount)

        // 把計算後的「錢」塞進要輸出的 amount 裡
        outputData.amount = String(calculatedAmount)
      }
      console.log(outputData)
      // 2. 輸出的物件 amount 是 45，但組件內部的 adjustPriceItem.amount 依然是 9
      this.$emit('update:adjustPriceItem', outputData)
    },
    clearInput() {
      this.adjustPriceItem.amount = '0'
      const outputData = { ...this.adjustPriceItem }
      this.$emit('update:adjustPriceItem', outputData)
    },
  },
}
</script>

<style lang="scss" scoped></style>
